import DataAccess from './constants';
import API from './API'

const path = 'coupons'
let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);

export const getCouponProducts = (CouponCode) => {
    let newpath = path + "?CouponCode=" + CouponCode;
    return api.getData(newpath)
}